export default function Hero() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Historic%20red%20brick%20warehouse%20building%20with%20traditional%20German%20architecture%2C%20black%20and%20white%20photography%2C%20monochrome%20industrial%20heritage%20atmosphere%2C%20old%20leather%20factory%20converted%20to%20modern%20fulfillment%20center%2C%20dramatic%20lighting%20and%20shadows%2C%20professional%20black%20and%20white%20photography%20style%2C%20high%20contrast%2C%20timeless%20and%20elegant%20ambiance&width=1920&height=1080&seq=hero-bg-bw&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white pt-56 md:pt-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Fulfillment mit
            <span className="block my-4">
              <span 
                className="block w-16 h-16 md:w-24 md:h-24 mx-auto"
                style={{
                  backgroundColor: '#B80E10',
                  maskImage: `url('https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/79499d1f5ec25a9869bbd3b528ad4633.svg')`,
                  WebkitMaskImage: `url('https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/79499d1f5ec25a9869bbd3b528ad4633.svg')`,
                  maskSize: 'contain',
                  WebkitMaskSize: 'contain',
                  maskRepeat: 'no-repeat',
                  WebkitMaskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  WebkitMaskPosition: 'center',
                }}
              />
            </span>
            <span className="block">und Hand</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            In der historischen Lederwarenfabrik in Remagen-Kripp packen wir jedes Paket 
            eigenhändig. Wie früher. Mit Sorgfalt. <strong>Handgepackt. Auch mit Liebe.</strong>
          </p>
        </div>
      </div>
      
      <div 
        className="absolute bottom-8 left-0 right-0 flex justify-center animate-bounce cursor-pointer"
        onClick={scrollToServices}
      >
        <i className="ri-arrow-down-line text-white text-2xl drop-shadow-lg hover:scale-110 transition-transform"></i>
      </div>
    </section>
  );
}